module.exports = __webpack_public_path__ + "img/Glasses copia.36b41665.svg";